import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from './skeleton.component';

@Component({
  selector: 'app-errors-loader',
  standalone: true,
  imports: [CommonModule, SkeletonComponent],
  template: `
    <div class="parent">
      <div class="flex gap-default items-center">
        <app-skeleton
          [style]="{ borderRadius: '50%', height: '0.5rem', width: '0.5rem' }"
        ></app-skeleton>

        <app-skeleton
          [style]="{ width: '6rem', height: '1.5rem' }"
        ></app-skeleton>
      </div>

      <app-skeleton
        [times]="3"
        [style]="{ width: '90%', height: '0.75rem', marginBottom: '0.35rem' }"
      ></app-skeleton>
      <app-skeleton [style]="{ width: '70%' }"></app-skeleton>

      <div class="flex justify-between items-center">
        <div class="flex gap-default">
          <app-skeleton
            [style]="{ width: '10rem', height: '2rem', marginBottom: '0' }"
          ></app-skeleton>
          <app-skeleton
            [style]="{ width: '10rem', height: '2rem', marginBottom: '0' }"
          ></app-skeleton>
        </div>
        <app-skeleton
          [style]="{ width: '0.5rem', height: '2rem', marginBottom: '0' }"
        ></app-skeleton>
      </div>
    </div>

    <div class="parent" *ngFor="let _ of skeletonArray()">
      <div class="flex justify-between items-center">
        <div class="flex gap-default items-center">
          <app-skeleton
            [style]="{
              borderRadius: '50%',
              height: '0.5rem',
              width: '0.5rem',
              marginBottom: '0'
            }"
          ></app-skeleton>

          <app-skeleton
            [style]="{ width: '6rem', height: '1.5rem', marginBottom: '0' }"
          ></app-skeleton>
        </div>

        <div>
          <app-skeleton
            [style]="{ width: '5rem', height: '1.5rem', marginBottom: '0' }"
          ></app-skeleton>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .parent {
        padding: 1.1rem;
        padding-block-start: 1rem;
        border-radius: 0.75rem;
        border: 1px solid var(--editor-border-gray);
        margin-bottom: 0.75rem;
      }

      .flex {
        display: flex;
      }

      .gap-default {
        gap: 0.5rem;
      }

      .justify-between {
        justify-content: space-between;
      }

      .items-center {
        align-items: center;
      }
    `,
  ],
})
export class ErrorsLoaderComponent {
  protected skeletonArray(): Array<number> {
    return Array.from({ length: 3 }, (_, i) => i);
  }
}
